import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  addAddress,
  deleteAddress,
  updateAddress,
} from "../../../services/userService";
import { useCookies } from "react-cookie";
export default function Address({
  address,
  newAddress,
  setShowDeletedMessage,
}) {
  const { t } = useTranslation();
  const [userAddress, setAddress] = useState(address.address || "");
  const [disableButton, setDisableButton] = useState(true);
  const [hideAddress, setHideAddress] = useState(false);
  const [cookie] = useCookies(["access_token"]);

  const handleAddNew = () => {
    addAddress(userAddress, cookie.access_token);
  };

  const handleUpdate = () => {
    updateAddress(address.id, userAddress, cookie.access_token);
  };

  const handleDelete = () => {
    deleteAddress(address.id, cookie.access_token).then(() => {
      setHideAddress(true);
      setShowDeletedMessage(true);
    });
  };
  return (
    <>
      {!hideAddress && !newAddress && (
        <div className="address">
          <div className="input-fields">
            <div className="input">
              <label htmlFor="">{t("user-address")}</label>
              <input
                type="text"
                value={userAddress}
                onChange={(e) => {
                  setDisableButton(false);
                  setAddress(e.target.value);
                }}
              />
            </div>
          </div>
          <div className="buttons">
            <button
              disabled={disableButton}
              className={disableButton ? "disabled" : ""}
              onClick={handleUpdate}
            >
              {t("save")}
            </button>
            <button className="delete border" onClick={handleDelete}>
              {t("delete")}
            </button>
          </div>
        </div>
      )}
      {newAddress && (
        <div className="address">
          <div className="input-fields">
            <div className="input">
              <label htmlFor="">{t("user-address")}</label>
              <input
                type="text"
                value={userAddress}
                onChange={(e) => {
                  setDisableButton(false);
                  setAddress(e.target.value);
                }}
              />
            </div>
          </div>
          <div className="buttons">
            <button
              disabled={disableButton}
              className={disableButton ? "disabled" : ""}
              onClick={handleAddNew}
            >
              {t("save")}
            </button>
          </div>
        </div>
      )}
    </>
  );
}
